/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RestoreOktaServerSuggestionRequestBody,
  RestoreOktaServerSuggestionRequestBody$Outbound,
  RestoreOktaServerSuggestionRequestBody$outboundSchema,
} from "../components/restoreoktaserversuggestionrequestbody.js";

export type RestoreOktaServerSuggestionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RestoreOktaServerSuggestionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  restoreOktaServerSuggestionRequestBody:
    RestoreOktaServerSuggestionRequestBody;
};

/** @internal */
export type RestoreOktaServerSuggestionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RestoreOktaServerSuggestionSecurity$outboundSchema: z.ZodMiniType<
  RestoreOktaServerSuggestionSecurity$Outbound,
  RestoreOktaServerSuggestionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function restoreOktaServerSuggestionSecurityToJSON(
  restoreOktaServerSuggestionSecurity: RestoreOktaServerSuggestionSecurity,
): string {
  return JSON.stringify(
    RestoreOktaServerSuggestionSecurity$outboundSchema.parse(
      restoreOktaServerSuggestionSecurity,
    ),
  );
}

/** @internal */
export type RestoreOktaServerSuggestionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RestoreOktaServerSuggestionRequestBody:
    RestoreOktaServerSuggestionRequestBody$Outbound;
};

/** @internal */
export const RestoreOktaServerSuggestionRequest$outboundSchema: z.ZodMiniType<
  RestoreOktaServerSuggestionRequest$Outbound,
  RestoreOktaServerSuggestionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    restoreOktaServerSuggestionRequestBody:
      RestoreOktaServerSuggestionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      restoreOktaServerSuggestionRequestBody:
        "RestoreOktaServerSuggestionRequestBody",
    });
  }),
);

export function restoreOktaServerSuggestionRequestToJSON(
  restoreOktaServerSuggestionRequest: RestoreOktaServerSuggestionRequest,
): string {
  return JSON.stringify(
    RestoreOktaServerSuggestionRequest$outboundSchema.parse(
      restoreOktaServerSuggestionRequest,
    ),
  );
}
